<div class="wrapper flex vcenter">
  <div
    class="outter-box"
    role="checkbox"
    tabindex="0"
    [attr.aria-checked]="checked"
    [class.toggled-on]="checked"
    (click)="onClick()"
    (keydown.enter)="onClick()"
    (keydown.space)="onClick(); $event.preventDefault()"
  >
    @if (checked) {
      <div class="inner-box"></div>
    }
  </div>
  <ng-content></ng-content>
</div>
